/**
 * Site Builder fidelity P3 — global footer HTML slot helpers.
 * OD-2: raw passthrough for tenant-staff HTML (parity with Custom HTML block).
 * Strip <script> only; iframes (map embeds) are permitted.
 */

export function stripScriptTags(html) {
  if (!html) return '';
  return String(html).replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '');
}

/** True when footer_html has non-whitespace content after script strip. */
export function hasFooterHtml(html) {
  return Boolean(stripScriptTags(html).trim());
}
